import React from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Stack,
  Divider,
  CircularProgress,
} from "@mui/material";

// trigger checkbox
export const ColumnViewPanel = ({
  columnView,
  setColumnView,
  additionalInfoFields = [],
  additionalInfoColumnView = {},
  setAdditionalInfoColumnView,
  loadingAdditionalInfoFields = false,
}) => (
  <Box
    sx={{
      position: "absolute",
      left: 0,
      top: 0,
      height: "calc(100vh - 450px)",
      width: "200px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      border: "1px solid #E5E7EB",
      boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1)",
      display: "flex",
      flexDirection: "column",
      zIndex: 1,
    }}
  >
    <Typography
      variant="subtitle2"
      sx={{
        color: "#344054",
        fontWeight: 600,
        p: 2,
        borderBottom: "1px solid #E5E7EB",
      }}
    >
      Column View
    </Typography>
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        p: 2,
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#cbd5e1",
          borderRadius: "3px",
        },
      }}
    >
      <Stack spacing={1}>
        {Object.entries(columnView).map(([key, value]) => {
          // Map keys to user-friendly labels
          const labelMap = {
            company: "Company",
            branch: "Branch",
            product: "Product",
            ipAddress: "IP Address",
            location: "Location",
            googleMapLink: "Google Map Link",
            latitudeLongitude: "Latitude & Longitude",
            os: "OS",
            browser: "Browser",
            deviceType: "Device Type",
            scanCount: "Scan Count",
            scanLimit: "Scan Limit",
            serialNumber: "Serial Number",
            productUuid: "Product UUID",
            status: "Status",
            scanDateTime: "Scan Date Time",
            branchId: "Branch ID",
          };
          return (
            <FormControlLabel
              key={key}
              sx={{
                m: 0,
                "& .MuiCheckbox-root": { p: "2px" },
                "& .MuiFormControlLabel-label": {
                  fontSize: "0.875rem",
                  color: "text.secondary",
                  ml: 1,
                },
              }}
              control={
                <Checkbox
                  checked={value}
                  onChange={(e) =>
                    setColumnView({
                      ...columnView,
                      [key]: e.target.checked,
                    })
                  }
                  size="small"
                />
              }
              label={
                labelMap[key] ||
                key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")
              }
            />
          );
        })}

        {/* Additional Info Fields Section */}
        {(additionalInfoFields.length > 0 || loadingAdditionalInfoFields) && (
          <>
            <Divider sx={{ my: 1.5 }} />
            <Typography
              variant="caption"
              sx={{
                color: "#667085",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                mb: 1,
              }}
            >
              Additional Info
            </Typography>

            {loadingAdditionalInfoFields ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 1 }}>
                <CircularProgress size={20} />
              </Box>
            ) : (
              additionalInfoFields.map((field) => {
                const label =
                  field.title?.EN ||
                  field.title?.TH ||
                  Object.values(field.title || {})[0] ||
                  field.uuid;
                return (
                  <FormControlLabel
                    key={field.uuid}
                    sx={{
                      m: 0,
                      "& .MuiCheckbox-root": { p: "2px" },
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.875rem",
                        color: "text.secondary",
                        ml: 1,
                      },
                    }}
                    control={
                      <Checkbox
                        checked={additionalInfoColumnView[field.uuid] || false}
                        onChange={(e) =>
                          setAdditionalInfoColumnView({
                            ...additionalInfoColumnView,
                            [field.uuid]: e.target.checked,
                          })
                        }
                        size="small"
                      />
                    }
                    label={label}
                  />
                );
              })
            )}
          </>
        )}
      </Stack>
    </Box>
  </Box>
);
